import React from 'react';
import { BaseFieldProps, useShowContextRequired } from 'ui-builder';
import { get } from 'lodash';
import DOMPurify from 'dompurify';

export function WysiwygField(props: BaseFieldProps) {
  const showContext = useShowContextRequired();

  const value = get(showContext.data, props.source);

  return (
    <div
      className={props.className}
      dangerouslySetInnerHTML={{ __html: value ? DOMPurify.sanitize(value) : '' }}
    />
  );
}
